<script>
    let sticky = '';
    let y
    
    function navigationbarEvent() {
        if (y > 700) {
            sticky = 'sticky'
        }else{
            sticky = ''
        }
    }
    
    $: y && navigationbarEvent()

    let lineId = "coco-nusa"
</script>

<!--====== HEADER PART START ======-->

    <header id="home" class="header-area pt-100">

        <!-- <div class="shape header-shape-one">
            <img src="assets/images/banner/shape/shape-1.png" alt="shape">
        </div>  -->
        <!-- header shape one -->

        <div class="shape header-shape-tow animation-one">
            <img src="assets/images/banner/shape/shape-2.png" alt="shape">
        </div> 
        <!-- header shape tow -->

        <!-- <div class="shape header-shape-three animation-one">
            <img src="assets/images/banner/shape/shape-3.png" alt="shape">
        </div>  -->
        <!-- header shape three -->

        <!-- <div class="shape header-shape-fore">
            <img src="assets/images/banner/shape/shape-4.png" alt="shape">
        </div> -->
         <!-- header shape three -->

        <div class="navigation-bar {sticky}">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <nav class="navbar navbar-expand-lg">
                            <a class="navbar-brand" href="#">
                                {#if sticky == 'sticky'}
                                <img src="assets/images/logocnk.png" alt="Logo">
                                {:else}
                                <img src="assets/images/logocnkwhite.png" alt="Logo">
                                {/if}
                            </a>
                            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="toggler-icon"></span>
                                <span class="toggler-icon"></span>
                                <span class="toggler-icon"></span>
                            </button>

                            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul id="nav" class="navbar-nav ml-auto">
                                    <li class="nav-item active">
                                        <a class="page-scroll" href="#home">Home</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="page-scroll" href="#about">About</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="page-scroll" href="#menu">Commodity</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="page-scroll" href="#order">How To Order</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="page-scroll" href="#team">Team</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="page-scroll" href="#footer">Contact</a>
                                    </li>
                                </ul> <!-- navbar nav -->
                            </div>
                            <div class="navbar-btn ml-20 d-none d-sm-block">
                                <a class="main-btn" href="https://wa.me/628125634464?text=Please%20I%20need%20more%20to%20know%20about%20PT%20Coco%20Nusa%20Khatulistiwa" target="blank"><i class="lni lni-whatsapp"></i>+62 812-5634-464</a>
                            </div>
                        </nav> <!-- navbar -->
                    </div>
                </div> <!-- row -->
            </div> <!-- container -->
        </div> <!-- navigation bar -->

        <div class="header-banner d-flex align-items-center">
            <div class="container">
                <div class="row">
                
                    <div class="col-xl-8 col-lg-9 col-sm-10">
                        <div class="banner-content">
                            <h4 class="sub-title wow fadeInUp" data-wow-duration="1.5s" data-wow-delay="1s">The Supplier of Coconut Product</h4>
                            <h1 class="banner-title mt-10 wow fadeInUp" data-wow-duration="1.5s" data-wow-delay="2s">We Bring Trust and Quality
</h1>
                            <a class="banner-contact mt-25 wow fadeInUp" data-wow-duration="1.5s" data-wow-delay="2.3s" href="#contact">COCO NUSA KHATULISTIWA</a>
                            <div class="navbar-btn mt-20 d-none d-sm-block wow fadeInUp" data-wow-duration="1.5s" data-wow-delay="2.3s">
                                <a class="main-btn" href="https://drive.google.com/file/d/1Y37sQsi0521ma-JOU4eA-cMLuD8UWcoE/view?usp=drive_link" target="blank"><i class="lni lni-download"></i>Download Catalog</a>
                            </div>
                        </div> <!-- banner content -->
                    </div>
                    
                </div> <!-- row -->
            </div> <!-- container -->
        </div> <!-- header banner -->

    </header>

    <!--====== HEADER PART ENDS ======-->

    <style>

    </style>

    <svelte:window bind:scrollY="{y}"/>

    <svelte:head>

    </svelte:head>